import { render } from "./activities.vue?vue&type=template&id=e12c72b4&scoped=true"
import script from "./activities.vue?vue&type=script&lang=js"
export * from "./activities.vue?vue&type=script&lang=js"

import "./activities.vue?vue&type=style&index=0&id=e12c72b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12c72b4"]])

export default __exports__